import BaseRepository from "./BaseRepository";

export default class ReportRepository extends BaseRepository {

	constructor() {
		super();
        this.create = this.create.bind(this);
        this.get = this.get.bind(this);
        
    }
    
    async create(user_id, body) {
        return await this.post(`/user/${user_id}/reports`, body);
    }

    async getOne(user_id) {
        return await this.get(`/user/${user_id}/reports`);
    }
}


// WEBPACK FOOTER //
// src/api/lib/ReportRepository.js